export enum AccountStatus {
  unverified = 'unverified',
  verified = 'verified',
  activated = 'activated',
  invitation_sent = 'invitation_sent',
  disabled = 'disabled',
}

export type GetAccountsResponse = {
  totalItems: number;
  items: Account[];
  page?: number;
  perPage?: number;
  totalPages?: number;
};

export type Account = {
  id: number;
  uuid: string;
  firstName?: string;
  lastName?: string;
  enabled?: boolean;
  email: string;
  roleId?: number;
  lastLogin?: Date;
  status?: AccountStatus;
  createdAt?: string;
  updatedAt?: Date;
};

export type UpdateAccountPayload = {
  firstName?: string;
  lastName?: string;
  email?: string;
  enabled?: boolean;
};

// All non-default color variants for Chip
export enum ChipStyleEnum {
  Pink = 'Pink',
  Beige = 'Beige',
  Blue = 'Blue',
  Green = 'Green',
}

export type SortableAccountColumns
  = 'name' | 'email' | 'role' | 'lastLogin' | 'signupDate' | 'status';

export type SortOrders
  = 'asc' | 'desc';
